import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/meeting-fill.svg'


const _hoisted_1 = { class: "card hover:bg-gray-50 cursor-pointer p-4" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-2" }
const _hoisted_3 = { class: "col-span-12 md:col-span-6 lg:col-span-5 xl:col-span-3" }
const _hoisted_4 = { class: "flex justify-start items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: /*#__PURE__*/_normalizeClass(['h-6 w-6']),
  src: _imports_0,
  alt: "meetings icon"
}, null, -1)
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "font-bold text-sm" }
const _hoisted_9 = { class: "text-sm italic ml-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold not-italic" }, "•", -1)
const _hoisted_11 = { class: "text-sm italic ml-1" }
const _hoisted_12 = { class: "col-span-3 md:col-span-2 lg:col-span-2 xl:col-span-1" }
const _hoisted_13 = { class: "col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2" }

import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		computed
	} from 'vue'

	
	const __default__ = { name: 'MeetingCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: { 
		meeting: {
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const store = localesStore()

	const startTime = computed(() => {
		return props.meeting.StartTime || props.meeting["job__FC_CALENDAR_EVENT__jobID::StartTime"]
	})

	const endTime = computed(() => {
		return props.meeting.EndTime || props.meeting["job__FC_CALENDAR_EVENT__jobID::EndTime"]
	})

return (_ctx: any,_cache: any) => {
  const _component_data_display = _resolveComponent("data-display")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: {name: 'MeetingDetails', params: {recordId: props.meeting.recordId}}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("h2", {
                title: props.meeting.Title || props.meeting['job__FC_CALENDAR_EVENT__jobID::Title'],
                class: "text-lg truncate"
              }, _toDisplayString(props.meeting.Title || props.meeting["job__FC_CALENDAR_EVENT__jobID::Title"]), 9, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(props.meeting.StartDate || props.meeting["job__FC_CALENDAR_EVENT__jobID::StartDate"]) + " • ", 1),
              _createElementVNode("p", _hoisted_9, [
                _createTextVNode(_toDisplayString(props.meeting.Type_display || props.meeting["job__FC_CALENDAR_EVENT__jobID::Type_display"]) + " ", 1),
                _hoisted_10
              ]),
              _createElementVNode("p", _hoisted_11, " ID: " + _toDisplayString(props.meeting.Id || props.meeting["job__FC_CALENDAR_EVENT__jobID::_kp_fccalendarevents_id"]), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_data_display, {
              label: _unref(store).getLabel('144'),
              value: _ctx.$filters.convertTime(startTime.value) || '—'
            }, null, 8, ["label", "value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_data_display, {
              label: _unref(store).getLabel('322'),
              value: _ctx.$filters.convertTime(endTime.value) || '—'
            }, null, 8, ["label", "value"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})